import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { SvgIconComponent } from "@mui/icons-material";

interface FlowStepCardProps {
  step: number;
  title: string;
  description: string;
  icon: SvgIconComponent;
}

function FlowStepCard({ step, title, description, icon: Icon }: FlowStepCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, height: "100%" }}>
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "primary.main",
              color: "primary.contrastText",
              flexShrink: 0,
            }}
          >
            <Icon fontSize="small" />
          </Box>
          <Typography variant="overline" color="text.secondary">
            Step {step}
          </Typography>
        </Stack>
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
    </Paper>
  );
}

export default FlowStepCard;
